import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FlexRow } from 'ui-components/components/flex';
import { emptyObject } from 'ui-components/default-props/empty';
import { useEntitiesFulfillmentPlanProperty } from '../../../../hooks/entities/selectors/fulfillment-plans';
import { useEntitiesSalesOrder } from '../../../../hooks/entities/selectors/sales-orders';
import messages from './messages';
import style from './style.module.less';

const EditItemHeader = ({ fulfillmentPlanId, salesOrderId }) => {
  const salesOrder = useEntitiesSalesOrder(salesOrderId) || emptyObject;
  const salesOrdersFulfilledIds = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'salesOrdersFulfilledIds') || [];

  const messageDescriptor =
    salesOrdersFulfilledIds.length > 1 ? messages.editItemsForCombinedShipmentInstructions : messages.editItemInstructions;

  return (
    <div className={style.header}>
      <FlexRow className={style.instructions}>
        <FormattedMessage
          {...messageDescriptor}
          values={{
            orderNumber: salesOrder.orderNumber,
          }}
        />
      </FlexRow>
    </div>
  );
};

EditItemHeader.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  salesOrderId: PropTypes.string.isRequired,
};

export default EditItemHeader;
